import styled from "@emotion/styled";

export const DeviceFrame = styled.div``;
export const DeviceStripe = styled.div``;
export const DeviceButtons = styled.div``;
export const DevicePower = styled.div``;
export const DeviceContainer = styled.div`
  ${DeviceFrame}.device-frame {
    border-radius: 48px;
  }
  ${DeviceFrame} .device-screen {
    object-fit: fill;
  }
`;
